import posthog from 'posthog-js'
import { bootstrap as bootstrapGtag } from 'vue-gtag'

const STORAGE_KEY = 'cookieConsent'
const LEGACY_KEY = 'cookiesAccept'

export const CONSENT_ACCEPTED = 'accepted'
export const CONSENT_REJECTED = 'rejected'

export function getConsent() {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    if (value === CONSENT_ACCEPTED || value === CONSENT_REJECTED) {
      return value
    }
    return null
  } catch (e) {
    return null
  }
}

export function hasConsent() {
  return getConsent() === CONSENT_ACCEPTED
}

// Enable or disable the trackers to match the given choice. Called on every
// page load (with the stored choice) and when the user makes a choice in the
// cookie dialog. Sentry stays outside consent: error tracking is functional.
//
// PostHog runs with cookieless_mode: 'on_reject' — opted out means it keeps
// counting anonymously via a server-side daily hash without storing anything
// on the device (events carry $cookieless_mode), which requires no consent.
// NB: mag pas ná Vue.use(VueGtag, …) draaien — bootstrapGtag() leest de
// opties die de plugin-installatie zet en crasht daarvóór. Elke stap staat in
// een eigen try/catch: een falende tracker mag nooit de app-start of de
// cookie-dialog blokkeren.
export function applyConsent(value) {
  if (process.env.NODE_ENV === 'development') {
    return
  }
  if (value === CONSENT_ACCEPTED) {
    try {
      posthog.opt_in_capturing({ captureEventName: false })
    } catch (e) {
      console.warn('posthog opt-in failed:', e)
    }
    if (process.env.NODE_ENV === 'production') {
      try {
        bootstrapGtag()
      } catch (e) {
        console.warn('gtag bootstrap failed:', e)
      }
    }
  } else {
    try {
      posthog.opt_out_capturing()
    } catch (e) {
      console.warn('posthog opt-out failed:', e)
    }
  }
}

export function setConsent(value, source) {
  try {
    localStorage.setItem(STORAGE_KEY, value)
    localStorage.removeItem(LEGACY_KEY)
  } catch (e) {
    // storage unavailable; apply for this session only
  }
  applyConsent(value)
  captureConsentChoice(value, source)
}

// Meet hoe vaak mensen accepteren of weigeren. Bewust ná applyConsent:
// na accepteren wordt dit een normaal event, na weigeren een anoniem
// cookieless event (dat mag zonder toestemming). Vuurt alleen bij een echte
// keuze van de gebruiker, niet bij het her-toepassen op elke pageload.
function captureConsentChoice(value, source) {
  if (process.env.NODE_ENV === 'development') {
    return
  }
  try {
    posthog.capture('cookie_consent_choice', {
      choice: value,
      source: source || 'dialog'
    })
  } catch (e) {
    console.warn('consent choice capture failed:', e)
  }
}

export function resetConsent() {
  try {
    localStorage.removeItem(STORAGE_KEY)
    localStorage.removeItem(LEGACY_KEY)
  } catch (e) {
    // ignore
  }
}
